import React from 'react';
import { Star, ExternalLink } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';
import { Button } from './ui/button';

const REVIEW_URL = 'https://g.page/r/CS-0B32ryvyzEAI/review';

const GoogleReview = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-slate-900 via-blue-950/40 to-slate-900 relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute inset-0 opacity-15">
        <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-64 h-64 bg-yellow-500 rounded-full filter blur-[100px]"></div>
        <div className="absolute top-1/2 right-1/4 -translate-y-1/2 w-48 h-48 bg-blue-500 rounded-full filter blur-[80px]"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto bg-slate-800/60 border border-slate-700/50 rounded-2xl p-8 md:p-12 backdrop-blur-sm">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
            
            {/* Left: Text content */}
            <div className="flex-1 text-center md:text-left">
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
                Sua Opinião é <span className="text-yellow-400">Importante!</span>
              </h2>
              
              <p className="text-gray-300 mb-6">
                Clique no botão abaixo ou escaneie o QR Code e deixe sua avaliação no Google. 
                Avalie nosso atendimento, serviço concluído e solução aplicada!
              </p>

              {/* Stars */}
              <div className="flex items-center justify-center md:justify-start gap-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-7 h-7 text-yellow-400 fill-yellow-400" />
                ))}
                <span className="text-white font-bold ml-2 text-lg">5.0</span>
              </div>

              {/* CTA Button */}
              <Button
                onClick={() => window.open(REVIEW_URL, '_blank')}
                size="lg"
                className="bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-400 hover:to-orange-400 text-slate-900 font-bold px-8 py-6 text-base shadow-xl shadow-yellow-500/25 w-full md:w-auto"
              >
                <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                </svg>
                Avalie no Google
                <ExternalLink className="w-4 h-4 ml-2" />
              </Button>
            </div>

            {/* Right: QR Code */}
            <div className="flex flex-col items-center gap-3">
              <div className="bg-white p-4 rounded-xl shadow-lg shadow-blue-500/10">
                <QRCodeSVG
                  value={REVIEW_URL}
                  size={160}
                  level="H"
                  fgColor="#1e293b"
                  bgColor="#ffffff"
                />
              </div>
              <span className="text-slate-400 text-xs text-center">
                Escaneie para avaliar
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GoogleReview;
